import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@plugins/client/auth';
import { MultilanguageGuard } from '@plugins/client/multilanguage/multilanguage.guard';
import { PreferredMultilanguageGuard } from '@plugins/client/multilanguage/preferred-multilanguage.guard';
import { AdminPreloadStrategy } from '@plugins/client/routing/admin-preload-strategy';
import { queueGuards } from '@plugins/client/routing/queue.guard';

import { AppGuard } from './shared/guards/app.guard';
import { InstanceGuard } from './shared/guards/instance.guard';

const routes: Routes = [
  {
    path: 'admin',
    canActivate: [
      queueGuards([AuthGuard, InstanceGuard, MultilanguageGuard]),
      AppGuard,
    ],
    data: { role: 'editor' },
    loadChildren: () =>
      import('./modules/backoffice/backoffice.module').then(
        (m) => m.BackofficeModule,
      ),
  },
  {
    path: '',
    canActivate: [
      queueGuards([
        AuthGuard,
        InstanceGuard,
        MultilanguageGuard,
        PreferredMultilanguageGuard,
      ]),
      AppGuard,
    ],
    loadChildren: () =>
      import('./modules/frontend/frontend.module').then(
        (m) => m.FrontendModule,
      ),
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: AdminPreloadStrategy }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
